import { usePdfiumEngine } from "@embedpdf/engines/react";
import type { PdfEngine } from "@embedpdf/models";

// Resolved through the package so rspack emits it under the app's assetPrefix.
// The 4.5 MB binary is fetched at runtime, never bundled, and the upstream
// default would pull it from a public CDN the app cannot reach behind its login.
const WASM_URL = new URL(
  "@embedpdf/pdfium/pdfium.wasm",
  import.meta.url,
).toString();

export type PdfViewerEngine = {
  engine: PdfEngine<Blob> | null;
  isLoading: boolean;
  error: Error | null;
};

export function usePdfViewerEngine(): PdfViewerEngine {
  // fontFallback null: the default downloads CJK and Arabic font packs from a CDN.
  return usePdfiumEngine({
    wasmUrl: WASM_URL,
    worker: true,
    fontFallback: null,
  });
}
